module.exports = __webpack_public_path__ + "static/EmergingLeaders-img-bb50a14f5cc9be88e2b5048b432ef59e.jpg";